export const isMobileNumber = val => {
  const regex = /^[0-9]*$/;
  return regex.test(val) && val.length <= 10;
};

export const filterComment = val =>
  val.replace(/[^A-Za-z0-9 /,._\-?!#$%&*]/g, '');

export const isEightDigitAlphaNumeric = val => {
  const regex = /^[A-Za-z0-9]{0,8}$/;
  return regex.test(val);
};

export const isAlphaNumeric = val => {
  const regex = /^[a-zA-Z0-9]*$/;
  return regex.test(val);
};

export const isEwayNumber = val => {
  const regex = /^[0-9]*$/;
  return regex.test(val) && val.length <= 12;
};

export const isValidEmail = email => {
  return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email);
};

export const TRUCK_NUMBER_REGEX = /^([A-Z]{2}\d{1,2}[A-Z]{0,3}\d{4}|\d{2}[A-Z]{2}\d{4}[A-Z]{1,2})$/;
